export function getRowContainers(row) {
    return function getRowContainersFn(smartBay) {
        var _a;
        const { gridContent, allTiersKeys } = smartBay.getGridContent();
        const containers = [];
        for (const tierKey of allTiersKeys) {
            const currContent = (_a = gridContent[row]) === null || _a === void 0 ? void 0 : _a[tierKey];
            if (!currContent)
                continue;
            containers.push(...currContent.containers);
        }
        return {
            containers,
            tBaysStr: smartBay.tBaysStr,
            level: smartBay.level,
        };
    };
}
